import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";
import React from "react";
import BlueChip from "../texts/BlueChip";
import HighChart from "../charts/Highchart";
import { PerformanceDonut } from "../charts/PerformanceDonut";

const useOverallCardStyles = makeThemedStyles("OverallCard", (theme) => ({
  root: {
    width: "41.5em",
    fontSize: "10px",
    borderRadius: ".8em",
    border: "1px solid rgba(247, 247, 247, 1)",
    background: "linear-gradient( #E1F5FF 0%, #fff5 20%, #FFF5)",
    padding: "10px 20px 10px 20px",
  },
}));

export const OverallCard = React.memo((props: React.PropsWithChildren<{}>) => {
  const styles = useOverallCardStyles();

  return <div className={styles.root}>{props.children}</div>;
});
